import { inject } from '@aesop-fables/containr';
import { Predicate, predicate } from '@aesop-fables/scrinium';
import { Observable, combineLatest, map } from 'rxjs';
import { Predicates } from './Types';
import { drillDownWizardKey, DrillDownWizard } from '../services/drillDown';

@predicate(Predicates.OrganizationSelected)
export class OrgAdminRolesResolved implements Predicate {
  constructor(
    @inject(drillDownWizardKey)
    private readonly drillDownWizard: DrillDownWizard,
  ) {}

  createObservable(): Observable<boolean> {
    return combineLatest([
      this.drillDownWizard.initialized$,
      this.drillDownWizard.highestAccess$,
      this.drillDownWizard.highestRevenueAccess$,
    ]).pipe(
      map(
        ([initialized, highestAccess, highestRevenueAccess]) =>
          initialized && (highestAccess !== undefined || highestRevenueAccess !== undefined),
      ),
    );
  }
}
